<template>
    <v-card class="my-2">
        <v-card-title class="justify-center">Conversation "{{ conversation.description }}" started: {{ conversation.created_date }}</v-card-title>
        <v-divider v-if="conversation.metadata.huov_code!==''"></v-divider>
        <v-card-actions class="pa-4" v-if="hasBooking">
            <v-btn color="primary" small @click="viewFaq">View FAQ</v-btn>
            <v-btn color="primary" small @click="viewAcco">Acco Info</v-btn>
            <v-btn color="primary" small @click="viewBooking">Booking info</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" small @click="viewMore" v-if="!showMore">More</v-btn>
            <v-btn color="primary" small @click="viewMore" v-if="showMore">Less</v-btn>
        </v-card-actions>
        <v-card-actions class="pa-4" v-if="hasAcco&&!hasBooking">
            <v-btn color="primary" small @click="viewAcco">Acco Info</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" small @click="viewMore" v-if="!showMore">More</v-btn>
            <v-btn color="primary" small @click="viewMore" v-if="showMore">Less</v-btn>
        </v-card-actions>
        <v-card-text class="pa-4" v-if="showMore">
            <div v-for="file in files" :key="file.filename" class="py-2">
                <v-btn color="primary" small @click="startUpload(file.filename)">upLoad</v-btn>
                {{ file.filename }} (uploaded: {{ file.created_date }})
            </div>
        </v-card-text>

        <v-divider></v-divider>
        <v-row class="pt-4 pr-4">
            <v-col cols="11"><v-text-field class="px-4 pb-2" v-model="newMessage" label="Ask a question" dense></v-text-field></v-col>
            <v-col cols="1"><v-btn color="primary" small :disabled="disableSubmit" @click="submitQuestion">Submit</v-btn></v-col>
        </v-row>
        <v-divider></v-divider>
        <v-card-text>
            <v-row v-for="(message, index) in conversation.messages" :key="message.id">
                <v-col cols="3" v-if="index % 2!==0"></v-col>
                <v-col cols="9"><cardMessage :message="message"/></v-col>
                <v-col cols="3" v-if="index % 2===0"></v-col>
            </v-row>
        </v-card-text>
        <cardFaq ref="cardFaq"/>
    </v-card>
</template>

<script>
    import cardMessage from "@/components/syst/openai/cardMessage.vue";
    import cardFaq from "@/components/syst/openai/cardFaq.vue";
    export default {
        components: {
            cardMessage,
            cardFaq,
        },
        props: {
            conversation: {
                required: true,
            },
            files: {
                required: false,
                defailt: [],
            },
            hasBooking: {
                type: Boolean,
                required: false,
                default: false,
            },
            hasAcco: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data() {
            return {
                newMessage: "",
                disableSubmit: false,
                isBookingConversation: false,
                showMore: false,
            }
        },
        methods: {
            submitQuestion() {
                if (this.newMessage === "") {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: "Question text must be given",
                        color: "error",
                    });  
                    return
                }
                this.disableSubmit = true;

                this.$axios.post("ares/json/ares/syst/openai/submitQuestion.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "submitQuestion",
                    },
                    submitQuestion: {
                        conversation_id: this.conversation.id,
                        question: this.newMessage,
                    }
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                        this.disableSubmit = false;
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.submitQuestion.text,
                            color: res.data.submitQuestion.color,
                        });
                        this.$emit("updateData", res.data.submitQuestion.message_id);
                        this. newMessage = "";
                        this.disableSubmit = false;
                    }
                });
            },
            viewFaq() {
                this.$axios.post("ares/json/ares/syst/openai/getFaqGeneral.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getFaqGeneral",
                    },
                    getFaqGeneral: {
                    }
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        let tekst = "";
                        let last_cat = "";
                        for (let i=0; i<res.data.getFaqGeneral.items.length; i++) {
                            let item = res.data.getFaqGeneral.items[i];
                            if (item.categoryOms !== last_cat) {
                                if (last_cat !== "") {
                                    tekst += "\n\n";
                                }
                                tekst += "Category " + item.categoryOms + ":\n\n";
                                last_cat = item.categoryOms;
                            }
                            tekst += "Question:" + item.question + "\n";
                            tekst += "Answer  :" + item.answer + "\n";
                        }
                        this.$refs.cardFaq.openDialog("Villa for you FAQ's", tekst);
                    }
                });
            },
            viewAcco() {
                this.$axios.post("ares/json/ares/syst/openai/getDetailAccommodation.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getDetailAccommodation",
                    },
                    getDetailAccommodation: {
                        huov_code: this.conversation.metadata.huis_code,
                    }
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        let tekst = "";
                        let last_acco = "";
                        for (let i=0; i<res.data.getDetailAccommodation.items.length; i++) {
                            let item = res.data.getDetailAccommodation.items[i];
                            if (item.categoryOms !== last_acco) {
                                if (last_acco !== "") {
                                    tekst += "\n\n";
                                }
                                tekst += "Accommodation " + item.accommodation + ":\n\n";
                                last_acco = item.accommodation;
                            }
                            tekst += item.description + "\n";
                        }
                        this.$refs.cardFaq.openDialog("Villa for you Accommodation details", tekst);
                    }
                });
            },            
            viewBooking() {
                this.$axios.post("ares/json/ares/syst/openai/getDetailBooking.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getDetailBooking",
                    },
                    getDetailBooking: {
                        huov_code: this.conversation.metadata.huov_code,
                    }
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$refs.cardFaq.openDialog("Villa for you Booking details", res.data.getDetailBooking.description);
                    }
                });
            },            
            viewMore() {
                this.showMore = !this.showMore;
            },
            startUpload(filename) {
                this.$axios.post("ares/json/ares/syst/openai/uploadFileList.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "uploadFileList",
                    },
                    uploadFileList: [{
                        filename : filename,
                    }]
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.uploadFileList.text,
                            color: res.data.uploadFileList.color,
                        });
                    }
                });
            },            
        }
    }
</script>
